import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/Week.svg?react
const SvgWeek = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M5 19H3L3 5H5L5 19ZM19 19V5L3 5L3.01074 4.7959C3.1062 3.85435 3.85435 3.1062 4.7959 3.01074L5 3L19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.96435 21 3.113 20.2128 3.01074 19.2041L3 19H19Z",
	fill: "currentColor"
}), /* @__PURE__ */ React$1.createElement("path", {
	d: "M15.7038 21H8.29171V3L15.7038 3L15.7038 21ZM10.2917 5V19H13.7038L13.7038 5L10.2917 5Z",
	fill: "currentColor"
}));

//#endregion
//#region src/icons/WeekIcon.tsx
function WeekIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgWeek,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { WeekIcon as t };
//# sourceMappingURL=WeekIcon-DWHdWCpU.js.map